export default "__VITE_ASSET__ByJ1py7d__"